import { __decorate } from "tslib";
import { AutoEncoder, StringDecoder, field, IntegerDecoder } from '@simonbackx/simple-encoding';
export class UitpasPriceCheckRequest extends AutoEncoder {
}
__decorate([
    field({ decoder: IntegerDecoder })
], UitpasPriceCheckRequest.prototype, "basePrice", void 0);
__decorate([
    field({ decoder: IntegerDecoder, nullable: true })
], UitpasPriceCheckRequest.prototype, "reducedPrice", void 0);
__decorate([
    field({ decoder: StringDecoder, nullable: true })
], UitpasPriceCheckRequest.prototype, "uitpasEventId", void 0);
__decorate([
    field({ decoder: StringDecoder, nullable: true })
], UitpasPriceCheckRequest.prototype, "uitpasNumber", void 0);
export class UitpasPriceCheckResponse extends AutoEncoder {
}
__decorate([
    field({ decoder: IntegerDecoder })
], UitpasPriceCheckResponse.prototype, "price", void 0);
//# sourceMappingURL=UitpasPriceCheckRequest.js.map